import { OperationData, DuplicateOp } from './schema';
import { Graph } from '../graph';

export const duplicateSym = (params: {
  from: string;
  to: string;
  graph: Record<string, Graph.Resolution>;
}): OperationData[] => {
  const { from, to, graph } = params;

  const sourceResolution = graph[from];
  if (!sourceResolution) {
    // If source not found, return just the duplicate operation
    // The build-commits will handle the error
    return [
      {
        t: 'duplicate',
        symbol: from,
        newSymbol: to,
      } as DuplicateOp,
    ];
  }

  const ops: OperationData[] = [];

  // For relations, we need to duplicate each column separately to ensure
  // each column gets a unique identity based on its own operation
  if (sourceResolution.item.t === 'rel') {
    const relNode = sourceResolution.item.relNode;

    // First, duplicate the relation itself (this will create it with empty columns)
    // We'll modify build-commits to handle this case
    ops.push({
      t: 'duplicate',
      symbol: from,
      newSymbol: to,
    } as DuplicateOp);

    // Then duplicate each column from the source relation into the new relation
    // Each column gets its own operation, ensuring unique identities
    for (const [colName] of Object.entries(relNode.cols)) {
      ops.push({
        t: 'duplicate',
        relName: from, // Source relation
        name: colName, // Source column name
        newName: colName, // Keep the same column name in the duplicate
        newSymbol: to, // Target relation (used when newName is not provided)
      } as DuplicateOp);
    }
  } else {
    // For non-relation nodes, just duplicate the node itself
    ops.push({
      t: 'duplicate',
      symbol: from,
      newSymbol: to,
    } as DuplicateOp);
  }

  return ops;
};
